<template>
  <section>
    <ods-module :header="$t('networkElements')">
      <ods-col :md="24" v-if="!hasPermission" style="min-height: 100%;">
        <ods-module style="min-height: 100%">
          <ods-row type="flex" justify="center" style="margin-top: 2rem; font-size:120%">
            {{$t('userDontHaveAcces')}}
          </ods-row>
          <ods-row type="flex" justify="center" style="margin-top: 2rem">
            <ods-icon name="info" size="100" class="custom-placeholder"/>
          </ods-row>
        </ods-module>
      </ods-col>
      <async-table
          v-if="hasPermission"
          :data="data"
          :total="total"
          :loading="loading"
          @fetchData="getData"
      >
        <ods-table-column prop="name" :label="$t('name')">
          <template slot-scope="scope">
            <router-link v-if="scope.row.id" :to="{ name: 'NetworkElementEdit', params: { id: scope.row.id }}">
              <ods-button type="text" class="p-0">{{scope.row.name}}</ods-button>
            </router-link>
          </template>
        </ods-table-column>

        <ods-table-column prop="elementType" :label="$t('type')" />
        <ods-table-column :label="$t('order')" >
              <template slot-scope="scope" v-if="scope.row.order">
                {{ scope.row.order | formatNumber }}
              </template>
        </ods-table-column>
        <!--<ods-table-column prop="order" :label="$t('order')" />-->
      </async-table>
    </ods-module>
  </section>
</template>

<script>
import NetworkElementService from '@/services/NetworkElement'
import AsyncTable from '@/custom-components/AsyncTable'
import asyncTableCommon from '@/mixins/async-table'
import { mapState } from 'vuex'

export default {
  name: 'NetworkElementDashboard',
  components: {
    AsyncTable
  },
  computed: {
    ...mapState({
      userRole: state => state.userRoles.data
    })
  },
  mounted () {
    this.handlePermission()
  },
  mixins: [asyncTableCommon],
  data () {
    return {
      hasPermission: true,
      promise: (params) => NetworkElementService.getElements(params)
    }
  },
  methods: {
    handlePermission () {
      let rolesArray = Object.values(this.userRole)
      rolesArray.map(role => {
        if (role === 'ROLE_OPERATOR') {
          this.hasPermission = false
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_ADMIN') {
              this.hasPermission = true
            }
          })
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_SUPER_ADMIN') {
              this.hasPermission = true
            }
          })
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_MANAGER') {
              this.hasPermission = true
            }
          })
        }
      })
    }
  }
}
</script>
